import React from "react";

export default function ResumeFormat(props) {
    return (
        <div className="flex flex-col gap-2 items-center" onClick={props.handleStepChange}>
            <img src={props.format}  className="w-[239px] h-[335px] rounded-lg shadow border border-indigo-400 border-opacity-30" alt="" />
            <p className="text-center text-black text-base font-medium"></p>
        </div>
    )
}